import {gql} from '@apollo/client';

import {doQuerySafe} from 'graphql-client/ApolloWrappers';
import {BenchlingQueryResult, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

import {AllBoxSchemasWithRegistryQuery} from './__generated/AllBoxSchemasWithRegistryQuery';
import {AllContainerSchemasWithRegistryQuery} from './__generated/AllContainerSchemasWithRegistryQuery';
import {AllLocationSchemasWithRegistryQuery} from './__generated/AllLocationSchemasWithRegistryQuery';
import {AllPlateSchemasWithRegistryQuery} from './__generated/AllPlateSchemasWithRegistryQuery';

export const ALL_BOX_SCHEMAS_WITH_REGISTRY_QUERY = gql`
  query AllBoxSchemasWithRegistryQuery @skipAudit @engComponent(name: INVENTORY) {
    boxSchemas {
      ...BoxSchemaGraphQL
      registry {
        ...RegistryGraphQL
      }
    }
  }
  ${getFragmentWrapper('BoxSchema').fragment}
  ${getFragmentWrapper('Registry').fragment}
`;

export function useBoxSchemasQueryWithRegistry(): BenchlingQueryResult<AllBoxSchemasWithRegistryQuery> {
  return useBenchlingQuery<AllBoxSchemasWithRegistryQuery>(ALL_BOX_SCHEMAS_WITH_REGISTRY_QUERY);
}

export function doBoxSchemasWithRegistryQuery(): Promise<AllBoxSchemasWithRegistryQuery> {
  return doQuerySafe<AllBoxSchemasWithRegistryQuery, {}>({query: ALL_BOX_SCHEMAS_WITH_REGISTRY_QUERY});
}

export const ALL_CONTAINER_SCHEMAS_WITH_REGISTRY_QUERY = gql`
  query AllContainerSchemasWithRegistryQuery @skipAudit @engComponent(name: INVENTORY) {
    containerSchemas {
      ...ContainerSchemaGraphQL
      registry {
        ...RegistryGraphQL
      }
    }
  }
  ${getFragmentWrapper('ContainerSchema').fragment}
  ${getFragmentWrapper('Registry').fragment}
`;

export function useContainerSchemasQueryWithRegistry(): BenchlingQueryResult<AllContainerSchemasWithRegistryQuery> {
  return useBenchlingQuery<AllContainerSchemasWithRegistryQuery>(ALL_CONTAINER_SCHEMAS_WITH_REGISTRY_QUERY);
}

export function doContainerSchemasWithRegistryQuery(): Promise<AllContainerSchemasWithRegistryQuery> {
  return doQuerySafe<AllContainerSchemasWithRegistryQuery, {}>({
    query: ALL_CONTAINER_SCHEMAS_WITH_REGISTRY_QUERY,
  });
}

export const ALL_LOCATION_SCHEMAS_WITH_REGISTRY_QUERY = gql`
  query AllLocationSchemasWithRegistryQuery @skipAudit @engComponent(name: INVENTORY) {
    locationSchemas {
      ...LocationSchemaGraphQL
      registry {
        ...RegistryGraphQL
      }
    }
  }
  ${getFragmentWrapper('LocationSchema').fragment}
  ${getFragmentWrapper('Registry').fragment}
`;

export function useLocationSchemasQueryWithRegistry(): BenchlingQueryResult<AllLocationSchemasWithRegistryQuery> {
  return useBenchlingQuery<AllLocationSchemasWithRegistryQuery>(ALL_LOCATION_SCHEMAS_WITH_REGISTRY_QUERY);
}

export function doLocationSchemasWithRegistryQuery(): Promise<AllLocationSchemasWithRegistryQuery> {
  return doQuerySafe<AllLocationSchemasWithRegistryQuery, {}>({
    query: ALL_LOCATION_SCHEMAS_WITH_REGISTRY_QUERY,
  });
}

export const ALL_PLATE_SCHEMAS_WITH_REGISTRY_QUERY = gql`
  query AllPlateSchemasWithRegistryQuery @skipAudit @engComponent(name: INVENTORY) {
    plateSchemas {
      ...PlateSchemaGraphQL
      registry {
        ...RegistryGraphQL
      }
    }
  }
  ${getFragmentWrapper('PlateSchema').fragment}
  ${getFragmentWrapper('Registry').fragment}
`;

export function usePlateSchemasQueryWithRegistry(): BenchlingQueryResult<AllPlateSchemasWithRegistryQuery> {
  return useBenchlingQuery<AllPlateSchemasWithRegistryQuery>(ALL_PLATE_SCHEMAS_WITH_REGISTRY_QUERY);
}

export function doPlateSchemasWithRegistryQuery(): Promise<AllPlateSchemasWithRegistryQuery> {
  return doQuerySafe<AllPlateSchemasWithRegistryQuery, {}>({query: ALL_PLATE_SCHEMAS_WITH_REGISTRY_QUERY});
}
